import { ChangeEvent, useCallback } from 'react';

const useFormHelper = <TFields extends object>({
  setField,
  textFieldChangeCallback,
}: {
  setField: (key: keyof TFields, val: ValueOf<TFields>) => void;
  textFieldChangeCallback?: (field: keyof TFields, val: string) => void;
}) => {
  const onTextFieldChange = useCallback(
    (field: keyof TFields, event: ChangeEvent<HTMLInputElement>) => {
      const val = event.target.value;
      setField(field, val as ValueOf<TFields>);

      textFieldChangeCallback?.(field, val);
    },
    [setField, textFieldChangeCallback],
  );

  return { onTextFieldChange };
};

export default useFormHelper;
